{
  "nav_zuerich": "Zurigo",
  "nav_rapperswil": "Rapperswil & Lago di Zurigo",
  "nav_einsiedeln": "Einsiedeln & Ybrig",
  "l_opening_hours": "Orari di apertura",
  "l_contact": "Contatto",
  "l_prices": "Prezzi",
  "Monday": "Lunedì",
  "Tuesday": "Martedì",
  "Wednesday": "Mercoledì",
  "Thursday": "Giovedì",
  "Friday": "Venerdì",
  "Saturday": "Sabato",
  "Sunday": "Domenica",
  "l_address": "Indirizzo",
  "l_email": "Email",
  "l_telephone": "Telefono",
  "l_homepage": "Homepage",
  "l_place": "Luogo",
  "l_route": "Percorso",
  "l_change_map_style": "Cambiare stile della mappa",
  "l_filter_categories": "Filtrare le categorie",
  "l_to_overview": "Vai alla panoramica",
  "txt_intro_h": "Scopri, mangia, bevi, dormi, festeggia e rilassati a Zurigo e dintorni",
  "txt_intro_1": "Scopri Zurigo e i suoi dintorni in un modo nuovo! Che tu sia del posto o un turista, qui troverai informazioni utili su dove mangiare, bere, dormire, festeggiare e rilassarti. Immergiti nella diversità della nostra regione.",
  "txt_intro_2_zuerich": "Zurigo, la pulsante metropoli economica e culturale della Svizzera, offre un mix unico di tradizione e modernità. Scopri le incantevoli viuzze del centro storico, la vivace Bahnhofstrasse, il Lago di Zurigo e i numerosi musei e teatri.",
  "txt_intro_2_rapperswil": "Rapperswil sul Lago di Zurigo è una pittoresca cittadina con un centro storico storico, un bellissimo castello e un impressionante giardino di rose. Da qui puoi esplorare il Lago di Zurigo, ammirare le montagne circostanti e goderti la tranquillità della natura.",
  "txt_intro_2_eyz": "Einsiedeln è un famoso luogo di pellegrinaggio con un impressionante complesso monastico. Ybrig è una regione con numerosi sentieri escursionistici e possibilità per gli sport invernali. Qui troverai pace e relax in mezzo alle imponenti Alpi svizzere."
}